import { getCookie, setCookie } from "./cookies-service";
import { SYNCED_ACCOUNT_DATA } from "../constants/cookies";
const parseSyncedAccountData = (persistantCookies = {})=>{
    try {
        const raw = persistantCookies[SYNCED_ACCOUNT_DATA];
        return raw ? JSON.parse(raw) : {};
    } catch (e) {
        return {};
    }
};
export const getValue = (persistantCookies = {}, key)=>{
    const data = parseSyncedAccountData(persistantCookies);
    return data[key];
};
export const setValue = (key, value)=>{
    let data = {};
    try {
        const raw = getCookie(SYNCED_ACCOUNT_DATA);
        data = raw ? JSON.parse(raw) : {};
    } catch (e) {
        data = {};
    }
    data[key] = value;
    setCookie(SYNCED_ACCOUNT_DATA, JSON.stringify(data));
};
